import { connect } from 'react-redux';

import {
  hideReloginDialog,
  setReloginDialogLoaded,
  setReloginDialogLoading,
  showReloginDialog,
} from 'actions/reloginDialog';

import { isUsingSSO } from 'selectors/session';

import ReloginDialog from './ReloginDialog';

export const mapStateToProps = state => ({
  isLoading: state.reloginDialog.isLoading,
  isOpen: state.reloginDialog.isOpen && !isUsingSSO(state),
});

export const mapDispatchToProps = {
  hideReloginDialog,
  setReloginDialogLoading,
  setReloginDialogLoaded,
  showReloginDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReloginDialog);
